// import Carousel from '../partials/carousel';
import Glide, { Controls, Breakpoints, Swipe } from '@glidejs/glide/dist/glide.modular.esm';

export default {
    carousels: document.querySelectorAll('.gallery-section .glide'),
    init() {
        // Carousel.init();

        if (!this.carousels.length) return;
        this.carousels.forEach((carousel) =>
            new Glide(carousel, {
                type: 'slider',
                startAt: 0,
                focusAt: 0,
                bound: true,
                perView: 3,
                gap: 32,
                breakpoints: {
                    960: { perView: 2, gap: 24, peek: { before: 0, after: 32 } },
                    768: { perView: 2, gap: 24, peek: { before: 0, after: 32 } },
                    425: { perView: 1, gap: 16, peek: { before: 0, after: 32 } },
                },
            }).mount({ Controls, Breakpoints, Swipe })
        );
    },
};
